const ARTIFACT_ROOT_TAGS = [
  'risk_assessment',
  'tbm_scenario',
  'tbm_record',
  'cost_estimate',
  'cost_estimate_material_change',
  'cases',
  'laws',
] as const;

const ARTIFACT_BLOCK_PATTERN = new RegExp(
  `<(${ARTIFACT_ROOT_TAGS.join('|')})\\b[^>]*>[\\s\\S]*?(?:<\\/\\1>|$)`,
  'gi',
);

/**
 * Tool-control tags such as <action> are parsed only from assistant prose.
 * Artifact XML may legitimately use the same tag name for editable data, so
 * remove artifact blocks from the parser input before rendering action cards.
 */
export const stripArtifactMarkupForControlParsing = (source: string): string =>
  source.replace(ARTIFACT_BLOCK_PATTERN, '');
